/**
 * @generated SignedSource<<e9d50437cc6997b591a46e978896dc1c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type subSectionPostMagazineIndexArticleList$data = {
  readonly id: string;
  readonly items: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"postMagazinePrimaryContent" | "postMagazineSecondaryContent">;
      };
    }>;
  } | null | undefined;
  readonly " $fragmentType": "subSectionPostMagazineIndexArticleList";
};
export type subSectionPostMagazineIndexArticleList$key = {
  readonly " $data"?: subSectionPostMagazineIndexArticleList$data;
  readonly " $fragmentSpreads": FragmentRefs<"subSectionPostMagazineIndexArticleList">;
};

import subSectionPostMagazineIndexArticleListPaginationQuery_graphql from './subSectionPostMagazineIndexArticleListPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "items"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 7,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": subSectionPostMagazineIndexArticleListPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "subSectionPostMagazineIndexArticleList",
  "selections": [
    {
      "alias": "items",
      "args": null,
      "concreteType": "QueueItemConnection",
      "kind": "LinkedField",
      "name": "__subSectionPostMagazineIndexArticleListQuery__items_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QueueItemsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "postMagazinePrimaryContent"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "postMagazineSecondaryContent"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Queue",
  "abstractKey": null
};
})();

(node as any).hash = "7128f0af8559165eb5e9353d49e81669";

export default node;
